import controller from './controller';
import template from './template.html';
import styles from './styles.less';

routes.$inject = ['$stateProvider', '$urlRouterProvider'];

export default function routes($stateProvider, $urlRouterProvider){

	$stateProvider.state('main.addToAccount', {
		url: '/addToAccount',
		controllerAs: 'ctrl',
		controller: controller,
		template: template
	})


}


/** WEBPACK FOOTER **
 ** ./src/main/panels/addToAccount/routes.js
 **/